module.exports = __webpack_public_path__ + "static/img/2.c962bed7.png";